const convertLabel = (field) => {
  try {
    const result = field.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  } catch (e) {
    console.error(`Unable to convert label: ${e.message}`);
    return field;
  }
};

module.exports = convertLabel;
